export enum JudgementStatus {
  OPEN = "open",
  APPROVED = "approved",
  DISAPPROVED = "disapproved",
}
